import React, { memo, useRef } from 'react';
import styled from 'styled-components';
import { FlexColumn, Tooltip, useIsXOverflow } from '@equifinance/shared';
import { Application } from '../../../contexts/applications';

const ApplicantColumnContainer = styled(FlexColumn)`${({ theme }) => `
  width: 100%;
  max-width: 100%;
  gap: ${theme.padding[2]};
`}`;

const ApplicantNameText = styled.p`${({ theme }) => `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${theme.colours.neutral[2]};
  font-weight: ${theme.fontWeight.bold};
`}`;

const ApplicantNameContainer = styled.div`
  max-width: 100%;
`;

const Divider = styled.span`${({ theme }) => `
  height: ${theme.borderWidth[1]};
  background: ${theme.colours.primary[7]};
`}`;

const PostcodeText = styled.span`${({ theme }) => `
  color: ${theme.colours.neutral[2]};
`}`;

const Applicant = memo(({ name, id, index }: { name: string, id: string, index: number }) => {
  const nameRef = useRef<HTMLParagraphElement>(null);

  const isTruncated = useIsXOverflow(nameRef);

  return (
    <ApplicantNameContainer id={`applicant-${id}-${index}`}>
      <ApplicantNameText ref={nameRef}>{name || '-'}</ApplicantNameText>
      {isTruncated && (
        <Tooltip
          id={`applicant-${id}-${index}`}
          html={name}
          place="top"
        />
      )}
    </ApplicantNameContainer>
  );
});

export default function ApplicantColumn({ row }: { row: Application }): React.ReactElement {
  return (
    <ApplicantColumnContainer>
      <span>
        {row.applicantNames.map((applicant, index) => (
          <Applicant
            name={applicant}
            id={row.id}
            index={index}
            key={`${row.id}-${index.toString()}`}
          />
        ))}
      </span>
      <Divider />
      <PostcodeText>
        {`Postcode: ${row.securityAddressPostCode || '-'}`}
      </PostcodeText>
    </ApplicantColumnContainer>
  );
}
